module.exports = __webpack_public_path__ + "resources/img/img_secureguard_pm1.ec030fbed44f3e0b4488c460097e248e.png";